/**
 * A marca horizontal (mala + "Viajandos"), na versão do tema: fundo claro
 * usa a arte com texto preto; fundo escuro, a com texto branco. Os arquivos
 * vêm de `design/logo_*.png`, reduzidos e sem o fundo chapado
 * (`public/marca/`). É decorativa quando há texto ao lado; sozinha (splash,
 * login) carrega o nome do app no `alt`.
 */
import { useTheme } from '../theme/ThemeProvider';

export function Logo({ largura = 220, className = '', alt = 'Viajandos' }: { largura?: number; className?: string; alt?: string }) {
  const { name } = useTheme();
  const src = name === 'dark' ? '/marca/logo-escuro.png' : '/marca/logo-claro.png';
  // 720×236 (claro) e 720×231 (escuro): a proporção é praticamente a mesma.
  return <img className={`nv-logo ${className}`.trim()} src={src} alt={alt} width={largura} height={Math.round(largura * 0.325)} decoding="async" />;
}
